import type { Degree } from "@pdfking/math"
import { Center } from "@pdfking/math"

import type { PlotShape } from "#public"
import { PlotFunction } from "#public"

import { GroupMatrix } from "./GroupMatrix"
import { ShapeBounds } from "./ShapeBounds"

/** Turn a shape counter-clockwise around its own centre.
 *
 * Shapes carry no rotation of their own, so this is how anything gets turned:
 * the result is a `PlotGroup` pivoting on the shape's centre. One rule for every
 * shape and every angle — an angle equivalent to zero is the only shortcut, and
 * gives the shape straight back. */
export const RotateShape = (shape: PlotShape, rotation: Degree): PlotShape => {
  const angle = (((rotation % 360) + 360) % 360) as Degree
  if (angle === 0) return shape

  const origin = Center(ShapeBounds(shape))

  return {
    enum: PlotFunction.PLOT_GROUP,
    matrix: GroupMatrix({ origin, rotation: angle }),
    shapes: [shape],
  }
}
